import { Button, Table } from "antd";
import React, { useState } from "react";
import { withNamespaces } from "react-i18next";
import { useSelector } from "react-redux";
import moment from "moment";
import NewCashMovementModal from "./newCashMovementModal";
const { Column } = Table;

function CashMovements({ cashMovements, t, getRegisterSummary }) {
  const [addCashMovementModalOpen, setAddCashMovementModalOpen] =
    useState(false);
  const config = useSelector((state) => state.config);
  const settings = useSelector((state) => state.auth.settings);

  const currency =
    config.language === "arabic"
      ? settings.currency_local
      : settings.currency_english;
  return (
    <div>
      {addCashMovementModalOpen && (
        <NewCashMovementModal
          visible={addCashMovementModalOpen}
          getRegisterSummary={getRegisterSummary}
          movementType={addCashMovementModalOpen}
          onClose={() => {
            setAddCashMovementModalOpen(false);
          }}
        />
      )}
      <h6>{t("Cash Movements")}</h6>
      <div
        style={{ display: "flex", gap: 5, justifyContent: "flex-end" }}
        className="mb-2"
      >
        <Button
          type="danger"
          onClick={() => setAddCashMovementModalOpen("deduct")}
        >
          {t("Remove Cash")}
        </Button>
        <Button
          type="primary"
          onClick={() => setAddCashMovementModalOpen("add")}
        >
          {t("Add Cash")}
        </Button>
      </div>
      <Table
        id={"cashMovments"}
        dataSource={cashMovements}
        rowClassName={"text-center"}
        pagination={false}
      >
        <Column
          title={t("Type")}
          key="type"
          dataIndex={"type"}
          render={(value) => t(value)}
        />
        <Column
          title={`${t("Amount")} (${currency})`}
          key="amount"
          dataIndex={"amount"}
        />
        <Column
          title={t("Date")}
          key="created_date"
          dataIndex={"created_date"}
          render={(value) =>
            (!value && "-") || moment(value).format("MMM Do YYYY - h:mm a")
          }
        />
        <Column
          title={t("By")}
          key="created_by"
          dataIndex={"created_by__username"}
        />
        <Column title={t("Notes")} key="notes" dataIndex={"note"} />
      </Table>
    </div>
  );
}

export default withNamespaces()(CashMovements);
